import type { TLoginModalElement } from '@shared/dream-components';
import { LoginModalElement } from '@shared/dream-components';
import type { ReactNode } from 'react';
import { ClientOnly } from 'remix-utils/client-only';

import useGlobalModals from '~/components/GlobalModals/hooks/useGlobalModals';

interface Props {
  node: TLoginModalElement;
  children: ReactNode | ReactNode[];
}

const LoginModal = ({ node, children }: Props) => {
  const { handleCloseModal, currentModal } = useGlobalModals();

  return (
    <ClientOnly fallback={null}>
      {() => (
        <LoginModalElement
          element={node}
          isOpen={currentModal === 'login'}
          onOpenChange={(isOpen: boolean) => {
            if (!isOpen) {
              handleCloseModal({ preventScrollReset: true });
            }
          }}
        >
          {children}
        </LoginModalElement>
      )}
    </ClientOnly>
  );
};

export default LoginModal;
